// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y3SHb","rootMobile":"styles_rootMobile__2ATlb"};